import { render } from "./deleteMilestoneModal.vue?vue&type=template&id=33eaa2ea"
import script from "./deleteMilestoneModal.vue?vue&type=script&lang=js"
export * from "./deleteMilestoneModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__